"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var AnimationObject_1 = require("../AnimationObject");
var AnimationObjectsArray = (function (_super) {
    tslib_1.__extends(AnimationObjectsArray, _super);
    function AnimationObjectsArray(rawData, version) {
        var _this = _super.call(this, rawData, version) || this;
        _this.findByIndex = function (index) {
            return _this.backingArray[index - 1];
        };
        _this.elementAt = function (index) {
            return _this.backingArray[index];
        };
        _this.forEach = function (operation) {
            _this.backingArray.forEach(operation);
        };
        _this.filter = function (filter) {
            return _this.backingArray.filter(filter);
        };
        _this.push = function (element) {
            _this.backingArray.push(element);
        };
        _this.remove = function (element) {
            var index = _this.backingArray.indexOf(element);
            if (index >= 0) {
                _this.backingArray.splice(index, 1);
            }
        };
        _this.clear = function () {
            _this.backingArray = [];
        };
        _this.backingArray = [];
        rawData.forEach(function (elementRawData) {
            var element = _this.importElement(elementRawData, version);
            _this.backingArray[element.index - 1];
        });
        return _this;
    }
    Object.defineProperty(AnimationObjectsArray.prototype, "length", {
        get: function () {
            return this.backingArray.length;
        },
        enumerable: true,
        configurable: true
    });
    AnimationObjectsArray.prototype.toRawData = function () {
        var array = [];
        for (var i = 0; i < this.backingArray.length; i++) {
            var element = this.backingArray[i];
            element.index = i + 1;
            array.push(element.toRawData());
        }
        return array;
    };
    return AnimationObjectsArray;
}(AnimationObject_1.AnimationObject));
exports.AnimationObjectsArray = AnimationObjectsArray;
//# sourceMappingURL=AnimationObjectsArray.js.map